// import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { AutoFocus } from '@node_modules/primeng/autofocus';
import { Autoformat, ButtonView, Plugin } from 'ckeditor5';
// import {ButtonView} from '@ckeditor/ckeditor5-ui/src/button/buttonview.js';


export default class SourceEditingEnhanced extends Plugin {

    init() {
        const editor = this.editor;

        // Add a new button to the toolbar
        editor.ui.componentFactory.add('sourceEditingEnhanced', () => {
            const view = new ButtonView();
            view.set({
                label: 'Enhanced Source',
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.5 0 5 4.5v15.003h-16V0h11zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692L3 1.5z"/><path d="M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14l3.496-2.5zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22l-3.496 2.5zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0z"/></svg>',
                tooltip: true,
            });

            // Toggle source editing mode
            view.on('execute', () => {
                openSourceEditingModal(editor.getData(), newHtml => {
                    editor.setData(newHtml);
                });
            });
            return view;
        });

        // Optionally, you can add more enhancements here, e.g. validation, formatting, etc.
    }
}
// Hàm mở modal đơn giản (bạn nên thay bằng modal Angular/Bootstrap cho UX tốt hơn)
function openSourceEditingModal(currentHtml: string, onSave: (newHtml: string) => void) {

    // Tạo modal
    const modal = document.createElement('div');
    // Use CodeMirror for syntax highlighting and auto-formatting
    modal.innerHTML = `
        <div class="modal fade show" tabindex="-1" style="display:block;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit HTML Source</h5>
                        <button type="button" class="btn-close" id="closeSource" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                             <div id="editorContainer" style="height:70vh;border:1px solid #ccc;"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" id="saveSource">Save</button>
                        <button type="button" class="btn btn-secondary" id="closeSourceFooter">Close</button>
                    </div>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    // Wait for modal to be added to DOM and CodeMirror to load
    setTimeout(() => {

        var ace = (window as any).ace;
        const editorInstance = ace.edit("editorContainer");
        editorInstance.setTheme("ace/theme/tomorrow");
        editorInstance.session.setMode("ace/mode/html");
        editorInstance.setOptions({
            fontSize: "12pt",
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            showPrintMargin: false,
            highlightActiveLine: true,
            autoScrollEditorIntoView: true,
            enableAutoIndent: true,
            wrap: true,
        });
        
        editorInstance.setValue(currentHtml, -1);
        editorInstance.resize();

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
            
                setTimeout(() => {
                const beautify = ace.require("ace/ext/beautify");
                beautify.beautify(editorInstance.session);
                }, 50);

            });
        });
        
        const handleAction = (action: 'save' | 'close') => {
            if (action === 'save' && editorInstance) {
                onSave(editorInstance.getValue());
            }
     
            document.body.removeChild(modal);
        };

        // Attach events
        const closeBtn = modal.querySelector('#closeSource') as HTMLButtonElement;
        const closeFooterBtn = modal.querySelector('#closeSourceFooter') as HTMLButtonElement;
        const saveBtn = modal.querySelector('#saveSource') as HTMLButtonElement;

        closeBtn?.addEventListener('click', () => handleAction('close'));
        closeFooterBtn?.addEventListener('click', () => handleAction('close'));
        saveBtn?.addEventListener('click', () => handleAction('save'));
    }, 100);
}

// declare var require: any;

// function loadMonacoEditor() {
//   const baseUrl = 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.40.0/min/vs';

//   if ((window as any).monaco) {
//     this.initEditor();
//     return;
//   }

//   const loaderScript = document.createElement('script');
//   loaderScript.src = `${baseUrl}/loader.min.js`;
//   loaderScript.onload = () => {
//     require.config({ paths: { vs: baseUrl } });
//     require(['vs/editor/editor.main'], () => {
//       this.initEditor();
//     });
//   };
//   document.body.appendChild(loaderScript);
// }
